import { Card, MediaCard } from '@ui/themed';
import { t } from 'i18next';
import { setUpSalesAgentsGraphic, viewB2BCustomersGraphic } from '../../../assets';
import { useHandlers } from '../../../context/page-context';

export function CustomerGroupsToolsCard() {
  const { navigationHandler } = useHandlers();

  return (
    <Card>
      <Card.Header
        headingLevel="h2"
        primaryAction={{
          label: t('buttons:view_dashboard'),
          onClick: () => navigationHandler.navigate('/', { openInDashboard: true }),
        }}
      >
        {t('features:customer_group.pages.customer_groups_page.help_cards.header')}
      </Card.Header>
      <Card.Body>
        <div className="grid grid-cols-2 gap-4 pb-1">
          <MediaCard
            headingLevel="h3"
            title={t(
              'features:customer_group.pages.customer_groups_page.help_cards.invite_customers.title',
            )}
            description={t(
              'features:customer_group.pages.customer_groups_page.help_cards.invite_customers.description',
            )}
            imgSrc={setUpSalesAgentsGraphic}
            imgFit="contain"
            action={{
              content: t(
                'features:customer_group.pages.customer_groups_page.help_cards.invite_customers.action',
              ),
              onClick: () =>
                navigationHandler.navigate('/v2/customers/agents', { openInDashboard: true }),
            }}
          />

          <MediaCard
            headingLevel="h3"
            title={t(
              'features:customer_group.pages.customer_groups_page.help_cards.international.title',
            )}
            description={t(
              'features:customer_group.pages.customer_groups_page.help_cards.international.description',
            )}
            imgSrc={viewB2BCustomersGraphic}
            imgFit="contain"
            action={{
              content: t(
                'features:customer_group.pages.customer_groups_page.help_cards.international.action',
              ),
              onClick: () =>
                navigationHandler.navigate('/v2/customers/list', { openInDashboard: true }),
            }}
          />
        </div>
      </Card.Body>
    </Card>
  );
}
